interface AudioChunk {
  data: ArrayBuffer;
  timestamp: number;
}

/**
 * combine audio chunks into a single Blob
 */
export const combineAudioChunks = (chunks: AudioChunk[]): Blob => {
  const totalLength = chunks.reduce(
    (sum, chunk) => sum + chunk.data.byteLength,
    0,
  );
  const combined = new Uint8Array(totalLength);

  let offset = 0;
  chunks.forEach(chunk => {
    combined.set(new Uint8Array(chunk.data), offset);
    offset += chunk.data.byteLength;
  });

  return new Blob([combined], { type: 'audio/webm' });
};

/**
 * download audio as a file
 */
export const downloadAudioFile = (blob: Blob, filename: string): void => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

/**
 * Convert ArrayBuffer to base64 string
 */
export const arrayBufferToBase64 = (arrayBuffer: ArrayBuffer): string => {
  const uint8Array = new Uint8Array(arrayBuffer);
  const binary = Array.from(uint8Array, byte => String.fromCharCode(byte)).join(
    '',
  );
  return btoa(binary);
};
